import type { DocumentIdentifier } from '../useFetchDocument'

import { queryKeys } from './useQueryDocumentReminder'
import { useFetchDocumentReminder } from './useFetchDocumentReminder'

const getOnMutate = () => {
  const queryClient = useQueryClient()

  return ({ documentId }: DocumentIdentifier) => {
    queryClient.cancelQueries({
      ...queryKeys.byDocumentId({ documentId }),
    })
  }
}
const getOnSettled = () => {
  const queryClient = useQueryClient()

  return (_: any, _1: any, { documentId }: DocumentIdentifier) => {
    // TODO DEV-5693, DEV-5967 invalidate or update cache (only if include "schedule" was used)
    // TODO DEV-5967 invalidate or update cache (only if include "schedule" was used)

    queryClient.invalidateQueries({
      ...queryKeys.byDocumentId({ documentId }),
    })
  }
}

const create = () => {
  const { create } = useFetchDocumentReminder()

  return useMutation({
    mutationFn: create,
    onMutate: getOnMutate(),
    onSettled: getOnSettled(),
  })
}

const update = () => {
  const { update } = useFetchDocumentReminder()

  return useMutation({
    mutationFn: update,
    onMutate: getOnMutate(),
    onSettled: getOnSettled(),
  })
}

const drop = () => {
  const { drop } = useFetchDocumentReminder()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: drop,
    onMutate: getOnMutate(),
    onSuccess: (_, variables) => {
      // TODO DEV-5693, DEV-5967 invalidate or update cache (only if include "schedule" was used)
      // TODO DEV-5967 invalidate or update cache (only if include "schedule" was used)

      queryClient.setQueriesData(
        { ...queryKeys.byDocumentId(variables) },
        (oldData: { data: { id: string }[] } | undefined) =>
          !oldData?.data
            ? undefined
            : { data: oldData.data?.filter(({ id }) => id !== variables.reminderId) }
        ,
      )
    },
    onError: (_, variables) => {
      queryClient.invalidateQueries({
        ...queryKeys.byDocumentId(variables),
      })
    },
  })
}

export const useMutationDocumentReminder = {
  drop,
  create,
  update,
}
